import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idBancoPagamento: number | null, openState: boolean) => void,
    onActionExportar: (idBancoPagamento: number | null, openState: boolean) => void,

}

export const GenerateSaldoBancarioListaColumns = ({
    onActionEdit,
    onActionExportar,
}: Props): GridColDef[] => {
    return [
        {
            field: "nomeBanco",
            filterable: false,
            headerName: "Nome do Banco",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "nrAgencia",
            filterable: false,
            headerName: "N° da Agência",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "nrConta",
            filterable: false,
            headerName: "N° da Conta",
            flex: 1,
            minWidth: 120,
            sortable: false,
        },
        {
            field: "saldoFinal",
            filterable: false,
            headerName: "Valor Saldo",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "exportar",
            filterable: false,
            headerName: "Exportar",
            sortable: false,
            valueGetter: (_, row) => row['idBancoPagamento'] as number,
            renderCell: ({ value }) => {
                return (
                    <Button
                        onMouseDown={() => {
                            onActionExportar(value, true);
                        }}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Exportar
                    </Button>
                );
            },
        },
        {
            field: 'idBancoPagamento',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}